export default "__VITE_ASSET__12b48440__"